module.exports = __webpack_public_path__ + "media/src/images/app_icons/ios_splashscreens/iphonexsmax_splash-bea79f12a825c8fb3d74a8fd5839d521.png";